import { render, staticRenderFns } from "./UserBox.vue?vue&type=template&id=90889894&scoped=true"
import script from "./UserBox.vue?vue&type=script&lang=js"
export * from "./UserBox.vue?vue&type=script&lang=js"
import style0 from "./UserBox.vue?vue&type=style&index=0&id=90889894&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90889894",
  null
  
)

export default component.exports